import { Loader2, Plus, SquarePen } from "lucide-react";
import { useTranslation } from "react-i18next";

import Icons from "@/components/icons";
import { Button } from "@/components/ui/v2/button";

type InvoiceAddEditButtonsProps = {
  isEditMode: boolean;
  onEditModeChange: (isEditMode: boolean) => void;
  onSave: () => void;
  onCancel: () => void;
  isEditDisabled?: boolean;
  isSaving?: boolean;
  hasData?: boolean;
  tabType?: "toDo" | "invoiced";
};

export function InvoiceAddEditButtons({
  isEditMode,
  onEditModeChange,
  onSave,
  onCancel,
  isEditDisabled = false,
  isSaving = false,
  hasData = false,
  tabType = "toDo",
}: InvoiceAddEditButtonsProps) {
  const { t } = useTranslation();

  if (!isEditMode) {
    // To-Do tab: Always show "Add Invoices" when there's data
    // Invoiced tab: Always show "Edit Invoices" (disabled when no data)
    const buttonLabel =
      tabType === "toDo"
        ? t("common.add")
        : t("common.edit");
    
    // Use Plus icon for Add action, SquarePen for Edit action
    const Icon = tabType === "toDo" ? Plus : SquarePen;

    return (
      <Button
        variant="outline"
        onClick={() => onEditModeChange(true)}
        disabled={!hasData || isEditDisabled}
      >
        <Icon /> {buttonLabel} {t("common.invoices")}
      </Button>
    );
  }

  return (
    <>
      <Button variant="outline" onClick={onCancel}>
        <Icons.CrossIcon fontSize={20} />
        {t("common.cancel")}
      </Button>
      <Button
        variant="default"
        onClick={onSave}
        disabled={isSaving || isEditDisabled}
      >
        {isSaving ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <Icons.CheckIcon fontSize={20} />
        )}
        {t("common.save")} {t("common.invoices")}
      </Button>
    </>
  );
}
